module.exports = __webpack_public_path__ + "static/media/Frame 315.77414795.png";